import { useWatchfaceStore } from '@/store/use-watchface-store';
import { computed } from 'vue';
import {
  useWatchfaceDevices,
  WatchfaceDeviceType
} from './use-watchface-devices';

export const useWatchfaceAndroid = () => {
  const watcfaceStore = useWatchfaceStore();
  const { findDeivce } = useWatchfaceDevices();

  /**
   * 这是一个计算属性，返回当前的 Android 手表操作系统版本
   * @returns {any} 返回当前的 Android 手表操作系统版本
   */
  const androidWatcfaceOS = computed(() => {
    return watcfaceStore.watchfaceDevice?.watchOS == 'android'
      ? watcfaceStore.description.watchOS ?? 'vela'
      : 'not-android-device';
  });

  const checkIsAndroid = (deviceType: WatchfaceDeviceType) => {
    return findDeivce(deviceType)?.watchOS == 'android';
  };

  return {
    checkIsAndroid,
    androidWatcfaceOS
  };
};
